import { useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchUserInventoryApi } from './userInventorySlice';
import DataTableFilter from '~/components/Datatable/ReactDatatableComponent/DataTableFilter';
import { MaterialReactTable } from 'material-react-table';
import useCardMetaData from '~/hooks/useCardMetaData';
import useHeroMetaData from '~/hooks/useHeroMetaData';
import { fields } from './constants.js';

// const columns = [
//     {
//         name: 'halfwish_id',
//         selector: (row) => row.halfwish_id,
//         sortable: true,
//     },
//     {
//         name: 'email',
//         selector: (row) => row.email,
//         sortable: true,
//     },
// ];

const customStyles = {
    headCells: {
        style: {
            fontWeight: 'bold', // override the cell padding for head cells
        },
    },
};

function UserInventory() {
    const [filterText, setFilterText] = useState('');
    const [isError, setIsError] = useState(false);
    const { rows, totalRows, perPage, page } = useSelector((state) => state.user.userInventory);

    const { isLoading } = useSelector((state) => state.loading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (rows.length > 0) return;

        (async function () {
            await fetchApi(page, perPage, filterText);
        })();
    }, []);

    const handlePageChange = async (page) => await fetchApi(page, perPage, filterText);

    const handlePerPageChange = async (perPage, page) => await fetchApi(page, perPage, filterText);

    const fetchApi = async (page, perPage, filterText) => {
        const params = {
            page,
            perPage,
            filterText
        };
        dispatch(fetchUserInventoryApi(params, navigate));
    };

    const handleClear = async () => {
        if (filterText) {
            setFilterText('');
            await fetchApi(page, perPage, '');
        }
    };

    const handleUpdateFilter = async () => {
        if (filterText != '') {
            await fetchApi(page, perPage, filterText);
        }
    };

    const { characterClasses, characterClassSkins } = useCardMetaData();
    const { heroes, equipments, consumables, dices } = useHeroMetaData();
    const metaData = [characterClasses, characterClassSkins, heroes, equipments, consumables, dices];

    const columns = useMemo(() => fields(...metaData), [...metaData]);

    return (
        <div className="col-sm-12">

            <div className="float-right">
                <DataTableFilter
                    onUpdateFilter={handleUpdateFilter}
                    onFilter={(e) => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                />
            </div>

            <MaterialReactTable
                enableStickyHeader
                getRowId={(row) => row.id} //give each row a more useful id
                columns={columns}
                data={rows}
                muiToolbarAlertBannerProps={
                    isError
                        ? {
                            color: 'error',
                            children: 'Error loading data',
                        }
                        : undefined
                }
                rowCount={totalRows}
                state={{
                    isLoading,
                    // pagination,
                    showAlertBanner: isError,
                    // columnFilters,
                }}
                positionPagination="top"
                enableGlobalFilter={false}
                enableColumnFilterModes={false}
                enableSorting={false}
                manualFiltering
                // onColumnFiltersChange={function (updater) {
                //     const newColumnFilters = updater(columnFilters);
                //     dispatch(setColumnFilters(newColumnFilters));
                //     dispatch(fetchPlayerInventories({ navigate, setIsError }));
                // }}
                initialState={{
                    showColumnFilters: false,
                    columnVisibility: {
                        hero: false,
                        familiar: false,
                        hero_skin: false,
                        dice_skin: false,
                        card_skin: false,
                        equipment: false,
                        emoji_voiceline: false,
                        player_icons: false,
                        hopium: false,
                        hwat: false,
                        consumable: false,
                        hero_token: false,
                    }
                }}
                muiTablePaginationProps={{
                    count: totalRows,
                }}
                manualPagination
                // onPaginationChange={function (updater) {
                //     const nextPagination = updater(pagination);
                //     dispatch(setPagination(nextPagination));
                //     dispatch(fetchPlayerInventories({ navigate, setIsError }));
                // }}
            />

            {/* <DataTable
                columns={columns}
                data={rows}
                fixedHeader
                striped
                pagination
                noDataComponent={<h3 className="m-3">No data...</h3>}
                progressPending={isLoading} //spinning icon will trigger when isLoading = 1
                progressComponent={
                    // eslint-disable-next-line prettier/prettier
                    <Spinner
                        animation="border"
                        role="status"
                    >
                        <span className="visually-hidden"></span>
                    </Spinner>
                }
                customStyles={customStyles}
                paginationServer
                persistTableHead
                onChangePage={handlePageChange}
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerPageChange}
                paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
                paginationPerPage={perPage}
                paginationDefaultPage={page}
            /> */}
        </div>
    );
}
//ref: https://codesandbox.io/s/gws1i?file=/src/App.js (datatable with filtering)
export default UserInventory;
